function delayedDirective($compile) {
    'ngInject';

    return {
        link(scope, element, attr) {
            scope[attr.ngDelayedWatch].then((logged) => {
                    element.attr(attr.ngDelayed, attr.ngDelayedValue);
                    element.attr('ng-delayed-value', null);
                    element.attr('ng-delayed-watch', null);
                    element.attr('ng-delayed', null);
                    $compile(element)(scope);
                    if (attr.ngDelayedReady) {
                        return scope[attr.ngDelayedReady].resolve(true);
                    }
                }
            );
        }
    };
}

angular
    .module('BB')
    .directive('ngDelayed', delayedDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/ng-delayed/ng_delayed.directive.js